import {
  FIELD_COLOR, FIELD_COLOR_ALT, FIELD_LINE_COLOR, GOAL_COLOR,
  BALL_RADIUS, PLAYER_RADIUS, GOAL_POST_WIDTH, GOAL_DEPTH, FIELD_MARGIN,
  dist, normalize
} from './constants';

// Sahayı çiz - FIFA tarzı geliştirilmiş
export function drawField(ctx, w, h) {
  // Stadyum arka planı (tribün efekti)
  const stadiumGrad = ctx.createLinearGradient(0, 0, 0, h);
  stadiumGrad.addColorStop(0, '#0a1f0a');
  stadiumGrad.addColorStop(0.05, '#1a3a1a');
  stadiumGrad.addColorStop(0.95, '#1a3a1a');
  stadiumGrad.addColorStop(1, '#0a1f0a');
  ctx.fillStyle = stadiumGrad;
  ctx.fillRect(0, 0, w, h);

  // Zemin - çim şeritleri (FIFA tarzı daha belirgin)
  const stripeWidth = Math.max(30, w / 20);
  for (let i = 0; i < w; i += stripeWidth) {
    const idx = Math.floor(i / stripeWidth);
    ctx.fillStyle = idx % 2 === 0 ? FIELD_COLOR : FIELD_COLOR_ALT;
    ctx.fillRect(i, 0, stripeWidth, h);
  }

  // Çim dokusu efekti
  ctx.fillStyle = 'rgba(255,255,255,0.015)';
  for (let y = 0; y < h; y += 3) {
    ctx.fillRect(0, y, w, 1);
  }

  // Kenar dışı bölge (daha koyu ve belirgin stadyum kenarı)
  const borderGrad = ctx.createLinearGradient(0, 0, 0, FIELD_MARGIN);
  borderGrad.addColorStop(0, 'rgba(10,20,10,0.6)');
  borderGrad.addColorStop(1, 'rgba(10,20,10,0.15)');
  ctx.fillStyle = borderGrad;
  ctx.fillRect(0, 0, w, FIELD_MARGIN - 2);
  
  const borderGrad2 = ctx.createLinearGradient(0, h - FIELD_MARGIN, 0, h);
  borderGrad2.addColorStop(0, 'rgba(10,20,10,0.15)');
  borderGrad2.addColorStop(1, 'rgba(10,20,10,0.6)');
  ctx.fillStyle = borderGrad2;
  ctx.fillRect(0, h - FIELD_MARGIN + 2, w, FIELD_MARGIN - 2);
  
  ctx.fillStyle = 'rgba(10,20,10,0.3)';
  ctx.fillRect(0, FIELD_MARGIN - 2, FIELD_MARGIN - 2, h - (FIELD_MARGIN - 2) * 2);
  ctx.fillRect(w - FIELD_MARGIN + 2, FIELD_MARGIN - 2, FIELD_MARGIN - 2, h - (FIELD_MARGIN - 2) * 2);

  // Reklam panoları efekti (kenar çizgisi dışı)
  ctx.fillStyle = 'rgba(200,200,200,0.08)';
  ctx.fillRect(FIELD_MARGIN - 8, 2, 6, h - 4);
  ctx.fillRect(w - FIELD_MARGIN + 2, 2, 6, h - 4);

  // Kenar çizgileri (parlak beyaz)
  ctx.strokeStyle = FIELD_LINE_COLOR;
  ctx.lineWidth = 3;
  ctx.shadowColor = 'rgba(255,255,255,0.3)';
  ctx.shadowBlur = 4;
  ctx.strokeRect(FIELD_MARGIN - 2, FIELD_MARGIN - 2, w - (FIELD_MARGIN - 2) * 2, h - (FIELD_MARGIN - 2) * 2);
  ctx.shadowBlur = 0;

  // Orta saha çizgisi
  ctx.strokeStyle = FIELD_LINE_COLOR;
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(w / 2, FIELD_MARGIN - 2);
  ctx.lineTo(w / 2, h - FIELD_MARGIN + 2);
  ctx.stroke();

  // Orta daire
  const circleR = Math.min(60, h * 0.15);
  ctx.beginPath();
  ctx.arc(w / 2, h / 2, circleR, 0, Math.PI * 2);
  ctx.stroke();

  // Orta nokta
  ctx.fillStyle = FIELD_LINE_COLOR;
  ctx.beginPath();
  ctx.arc(w / 2, h / 2, 4, 0, Math.PI * 2);
  ctx.fill();

  // Ceza sahaları
  const penaltyW = Math.min(120, w * 0.13);
  const penaltyH = h * 0.55;
  const penaltyY = (h - penaltyH) / 2;

  ctx.strokeStyle = FIELD_LINE_COLOR;
  ctx.lineWidth = 2;
  ctx.strokeRect(FIELD_MARGIN - 2, penaltyY, penaltyW, penaltyH);
  ctx.strokeRect(w - penaltyW - FIELD_MARGIN + 2, penaltyY, penaltyW, penaltyH);

  // Penaltı noktaları
  const penDotX1 = FIELD_MARGIN - 2 + penaltyW * 0.75;
  const penDotX2 = w - FIELD_MARGIN + 2 - penaltyW * 0.75;
  ctx.fillStyle = FIELD_LINE_COLOR;
  ctx.beginPath();
  ctx.arc(penDotX1, h / 2, 3, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.arc(penDotX2, h / 2, 3, 0, Math.PI * 2);
  ctx.fill();

  // Penaltı yayları (D çizgisi)
  ctx.beginPath();
  ctx.arc(penDotX1, h / 2, circleR * 0.6, -0.8, 0.8);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(penDotX2, h / 2, circleR * 0.6, Math.PI - 0.8, Math.PI + 0.8);
  ctx.stroke();

  // Kale alanları (küçük)
  const goalAreaW = Math.min(50, w * 0.06);
  const goalAreaH = h * 0.3;
  const goalAreaY = (h - goalAreaH) / 2;
  ctx.strokeRect(FIELD_MARGIN - 2, goalAreaY, goalAreaW, goalAreaH);
  ctx.strokeRect(w - goalAreaW - FIELD_MARGIN + 2, goalAreaY, goalAreaW, goalAreaH);

  // Korner yayları
  const cornerR = 12;
  ctx.beginPath();
  ctx.arc(FIELD_MARGIN - 2, FIELD_MARGIN - 2, cornerR, 0, Math.PI / 2);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(w - FIELD_MARGIN + 2, FIELD_MARGIN - 2, cornerR, Math.PI / 2, Math.PI);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(FIELD_MARGIN - 2, h - FIELD_MARGIN + 2, cornerR, -Math.PI / 2, 0);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(w - FIELD_MARGIN + 2, h - FIELD_MARGIN + 2, cornerR, Math.PI, Math.PI * 1.5);
  ctx.stroke();
}

// Kaleleri çiz - FIFA tarzı 3D efektli
export function drawGoals(ctx, w, h) {
  const goalW = GOAL_DEPTH;
  const goalH = h * 0.3;
  const goalY = (h - goalH) / 2;

  // Sol kale - 3D efekti
  // Kale ağı arka planı
  const netGrad1 = ctx.createLinearGradient(0, goalY, goalW, goalY);
  netGrad1.addColorStop(0, 'rgba(200,200,200,0.15)');
  netGrad1.addColorStop(1, 'rgba(255,255,255,0.03)');
  ctx.fillStyle = netGrad1;
  ctx.fillRect(0, goalY, goalW, goalH);

  // Kale ağ çizgileri (daha ince, gerçekçi)
  ctx.strokeStyle = 'rgba(255,255,255,0.12)';
  ctx.lineWidth = 0.5;
  for (let i = goalY; i < goalY + goalH; i += 8) {
    ctx.beginPath();
    ctx.moveTo(0, i);
    ctx.lineTo(goalW, i);
    ctx.stroke();
  }
  for (let i = 0; i < goalW; i += 8) {
    ctx.beginPath();
    ctx.moveTo(i, goalY);
    ctx.lineTo(i, goalY + goalH);
    ctx.stroke();
  }

  // Direkler (3D efektli)
  const postGrad = ctx.createLinearGradient(0, 0, GOAL_POST_WIDTH + 2, 0);
  postGrad.addColorStop(0, '#ffffff');
  postGrad.addColorStop(0.5, '#e8e8e8');
  postGrad.addColorStop(1, '#cccccc');
  ctx.fillStyle = postGrad;
  ctx.fillRect(goalW - 2, goalY, GOAL_POST_WIDTH + 2, goalH);
  ctx.fillRect(0, goalY, goalW, GOAL_POST_WIDTH + 1);
  ctx.fillRect(0, goalY + goalH - GOAL_POST_WIDTH - 1, goalW, GOAL_POST_WIDTH + 1);

  // Direk gölgesi
  ctx.fillStyle = 'rgba(0,0,0,0.15)';
  ctx.fillRect(goalW + GOAL_POST_WIDTH, goalY, 3, goalH);

  // Sağ kale - 3D efekti
  const netGrad2 = ctx.createLinearGradient(w - goalW, goalY, w, goalY);
  netGrad2.addColorStop(0, 'rgba(255,255,255,0.03)');
  netGrad2.addColorStop(1, 'rgba(200,200,200,0.15)');
  ctx.fillStyle = netGrad2;
  ctx.fillRect(w - goalW, goalY, goalW, goalH);

  ctx.strokeStyle = 'rgba(255,255,255,0.12)';
  ctx.lineWidth = 0.5;
  for (let i = goalY; i < goalY + goalH; i += 8) {
    ctx.beginPath();
    ctx.moveTo(w - goalW, i);
    ctx.lineTo(w, i);
    ctx.stroke();
  }
  for (let i = w - goalW; i < w; i += 8) {
    ctx.beginPath();
    ctx.moveTo(i, goalY);
    ctx.lineTo(i, goalY + goalH);
    ctx.stroke();
  }

  const postGrad2 = ctx.createLinearGradient(w - GOAL_POST_WIDTH - 2, 0, w, 0);
  postGrad2.addColorStop(0, '#cccccc');
  postGrad2.addColorStop(0.5, '#e8e8e8');
  postGrad2.addColorStop(1, '#ffffff');
  ctx.fillStyle = postGrad2;
  ctx.fillRect(w - goalW, goalY, GOAL_POST_WIDTH + 2, goalH);
  ctx.fillRect(w - goalW, goalY, goalW, GOAL_POST_WIDTH + 1);
  ctx.fillRect(w - goalW, goalY + goalH - GOAL_POST_WIDTH - 1, goalW, GOAL_POST_WIDTH + 1);

  ctx.fillStyle = 'rgba(0,0,0,0.15)';
  ctx.fillRect(w - goalW - GOAL_POST_WIDTH - 3, goalY, 3, goalH);
}

// Top çiz
export function drawBall(ctx, ball) {
  // Gölge
  ctx.fillStyle = 'rgba(0,0,0,0.3)';
  ctx.beginPath();
  ctx.ellipse(ball.x + 3, ball.y + ball.z * 0.3 + 3, BALL_RADIUS, BALL_RADIUS * 0.6, 0, 0, Math.PI * 2);
  ctx.fill();

  // Top
  const gradient = ctx.createRadialGradient(
    ball.x - 2, ball.y - ball.z * 0.3 - 2, 1,
    ball.x, ball.y - ball.z * 0.3, BALL_RADIUS
  );
  gradient.addColorStop(0, '#ffffff');
  gradient.addColorStop(0.7, '#e0e0e0');
  gradient.addColorStop(1, '#aaaaaa');
  
  ctx.fillStyle = gradient;
  ctx.beginPath();
  ctx.arc(ball.x, ball.y - ball.z * 0.3, BALL_RADIUS, 0, Math.PI * 2);
  ctx.fill();

  // Beşgen deseni
  ctx.fillStyle = 'rgba(0,0,0,0.2)';
  const r = BALL_RADIUS * 0.4;
  for (let i = 0; i < 5; i++) {
    const angle = (i * Math.PI * 2) / 5 + ball.spin;
    const px = ball.x + Math.cos(angle) * r;
    const py = ball.y - ball.z * 0.3 + Math.sin(angle) * r;
    ctx.beginPath();
    ctx.arc(px, py, 2, 0, Math.PI * 2);
    ctx.fill();
  }
}

// Oyuncu çiz - İnsan figürü
export function drawPlayer(ctx, player, isControlled) {
  const { x, y, teamColor, secondaryColor, isGoalkeeper, vx, vy } = player;

  // Hareket yönü (animasyon için)
  const speed = Math.sqrt((vx || 0) ** 2 + (vy || 0) ** 2);
  const isMoving = speed > 0.3;
  const time = Date.now() * 0.008;
  const legSwing = isMoving ? Math.sin(time * 3) * 6 : 0;
  const armSwing = isMoving ? Math.sin(time * 3) * 4 : 0;
  const bodyBob = isMoving ? Math.abs(Math.sin(time * 3)) * 1.5 : 0;

  // Ölçek
  const S = PLAYER_RADIUS * 0.08; // boyut çarpanı

  ctx.save();
  ctx.translate(x, y - bodyBob);

  // Gölge
  ctx.fillStyle = 'rgba(0,0,0,0.2)';
  ctx.beginPath();
  ctx.ellipse(2, 18 * S + bodyBob, 8 * S, 3 * S, 0, 0, Math.PI * 2);
  ctx.fill();

  // Bacaklar (şort altı ten rengi)
  const skinColor = '#D4A574';
  ctx.strokeStyle = skinColor;
  ctx.lineWidth = 3 * S;
  ctx.lineCap = 'round';
  // Sol bacak
  ctx.beginPath();
  ctx.moveTo(-3 * S, 6 * S);
  ctx.lineTo(-3 * S - legSwing * S * 0.5, 16 * S);
  ctx.stroke();
  // Sağ bacak
  ctx.beginPath();
  ctx.moveTo(3 * S, 6 * S);
  ctx.lineTo(3 * S + legSwing * S * 0.5, 16 * S);
  ctx.stroke();

  // Ayakkabılar (krampon)
  ctx.fillStyle = '#1a1a1a';
  ctx.beginPath();
  ctx.ellipse(-3 * S - legSwing * S * 0.5, 17 * S, 3 * S, 1.5 * S, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.ellipse(3 * S + legSwing * S * 0.5, 17 * S, 3 * S, 1.5 * S, 0, 0, Math.PI * 2);
  ctx.fill();

  // Şort
  ctx.fillStyle = secondaryColor || '#ffffff';
  ctx.beginPath();
  ctx.moveTo(-6 * S, 3 * S);
  ctx.lineTo(6 * S, 3 * S);
  ctx.lineTo(5 * S, 8 * S);
  ctx.lineTo(-5 * S, 8 * S);
  ctx.closePath();
  ctx.fill();

  // Gövde / Forma
  const jerseyGrad = ctx.createLinearGradient(0, -8 * S, 0, 5 * S);
  jerseyGrad.addColorStop(0, lightenColor(teamColor, 20));
  jerseyGrad.addColorStop(1, teamColor);
  ctx.fillStyle = jerseyGrad;
  ctx.beginPath();
  ctx.roundRect(-7 * S, -8 * S, 14 * S, 13 * S, 2 * S);
  ctx.fill();

  // Forma kenarlık
  ctx.strokeStyle = secondaryColor || 'rgba(0,0,0,0.3)';
  ctx.lineWidth = 1;
  ctx.stroke();

  // Kollar (ten rengi)
  ctx.strokeStyle = skinColor;
  ctx.lineWidth = 2.5 * S;
  ctx.lineCap = 'round';
  // Sol kol
  ctx.beginPath();
  ctx.moveTo(-7 * S, -4 * S);
  ctx.lineTo(-10 * S - armSwing * S * 0.3, 2 * S);
  ctx.stroke();
  // Sağ kol
  ctx.beginPath();
  ctx.moveTo(7 * S, -4 * S);
  ctx.lineTo(10 * S + armSwing * S * 0.3, 2 * S);
  ctx.stroke();

  // Kaleci eldivenleri
  if (isGoalkeeper) {
    ctx.fillStyle = '#f39c12';
    ctx.beginPath();
    ctx.arc(-10 * S - armSwing * S * 0.3, 2 * S, 2.5 * S, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(10 * S + armSwing * S * 0.3, 2 * S, 2.5 * S, 0, Math.PI * 2);
    ctx.fill();
  }

  // Kafa
  ctx.fillStyle = skinColor;
  ctx.beginPath();
  ctx.arc(0, -12 * S, 5 * S, 0, Math.PI * 2);
  ctx.fill();

  // Saç
  ctx.fillStyle = '#2c1810';
  ctx.beginPath();
  ctx.arc(0, -14 * S, 5 * S, Math.PI, Math.PI * 2);
  ctx.fill();

  // Forma numarası
  ctx.fillStyle = secondaryColor || 'white';
  ctx.font = `bold ${7 * S}px Arial`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(player.number || '', 0, -1 * S);

  ctx.restore();

  // Kontrol edilen oyuncu işareti (restore sonrası)
  if (isControlled) {
    // Üçgen ok
    ctx.fillStyle = '#f1c40f';
    ctx.beginPath();
    ctx.moveTo(x, y - 24 * S);
    ctx.lineTo(x - 5, y - 18 * S);
    ctx.lineTo(x + 5, y - 18 * S);
    ctx.closePath();
    ctx.fill();

    // Yerdeki halka
    ctx.strokeStyle = '#f1c40f';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.ellipse(x, y + 18 * S, 10 * S, 4 * S, 0, 0, Math.PI * 2);
    ctx.setLineDash([4, 3]);
    ctx.stroke();
    ctx.setLineDash([]);
  }

  // İsim etiketi
  if (isControlled || isGoalkeeper) {
    const name = player.name || '';
    ctx.font = 'bold 9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    const nameW = ctx.measureText(name).width + 8;
    ctx.fillStyle = 'rgba(0,0,0,0.7)';
    const nameY = y + 20 * S + 4;
    ctx.fillRect(x - nameW / 2, nameY - 6, nameW, 13);
    ctx.fillStyle = '#fff';
    ctx.fillText(name, x, nameY + 1);
  }
}

// Renk açma yardımcısı
function lightenColor(hex, percent) {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = Math.min(255, (num >> 16) + amt);
  const G = Math.min(255, ((num >> 8) & 0x00FF) + amt);
  const B = Math.min(255, (num & 0x0000FF) + amt);
  return `rgb(${R},${G},${B})`;
}

// Yön okunu çiz (şut/pas yönü) - çocuk dostu büyük ve renkli
export function drawAimArrow(ctx, fromX, fromY, toX, toY, color, label) {
  const dx = toX - fromX;
  const dy = toY - fromY;
  const len = Math.sqrt(dx * dx + dy * dy);
  if (len < 5) return;

  const maxLen = 120;
  const ratio = Math.min(len, maxLen) / maxLen;
  const endX = fromX + (dx / len) * maxLen * ratio;
  const endY = fromY + (dy / len) * maxLen * ratio;

  // Parlak ok gövdesi
  ctx.strokeStyle = color;
  ctx.lineWidth = 4;
  ctx.globalAlpha = 0.7;
  ctx.setLineDash([10, 5]);
  ctx.beginPath();
  ctx.moveTo(fromX, fromY);
  ctx.lineTo(endX, endY);
  ctx.stroke();
  ctx.setLineDash([]);

  // Ok ucu (üçgen)
  const angle = Math.atan2(dy, dx);
  const arrowSize = 12;
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.moveTo(endX, endY);
  ctx.lineTo(endX - arrowSize * Math.cos(angle - 0.4), endY - arrowSize * Math.sin(angle - 0.4));
  ctx.lineTo(endX - arrowSize * Math.cos(angle + 0.4), endY - arrowSize * Math.sin(angle + 0.4));
  ctx.closePath();
  ctx.fill();

  // Etiket (ne yapılacağını göster)
  if (label) {
    ctx.font = 'bold 11px Arial';
    ctx.textAlign = 'center';
    ctx.fillStyle = color;
    ctx.fillText(label, (fromX + endX) / 2, (fromY + endY) / 2 - 10);
  }

  ctx.globalAlpha = 1;
}

// Kontrol edilen oyuncunun yapabileceği hamleleri göster
export function drawActionIndicators(ctx, state) {
  if (state.phase !== 'playing') return;

  const team = state.controlledTeam === 'home' ? state.homeTeam : state.awayTeam;
  const player = team[state.controlledPlayerIndex];
  if (!player) return;

  const ball = state.ball;
  const d = dist(ball.x, ball.y, player.x, player.y);
  const nearBall = d < PLAYER_RADIUS + BALL_RADIUS + 15;

  if (!nearBall) {
    // Topa uzakken: topa doğru ok
    drawAimArrow(ctx, player.x, player.y, ball.x, ball.y, 'rgba(52,152,219,0.6)', '⚽ Topa Git');
    return;
  }

  // Top yakınındayken: şut ve pas yönlerini göster
  if (state.role === 'player') {
    // Şut yönü (kaleye doğru)
    const goalX = state.controlledTeam === 'home' ? state.canvasW - 10 : 10;
    const goalY = state.canvasH / 2;
    drawAimArrow(ctx, ball.x, ball.y, goalX, goalY, 'rgba(231,76,60,0.5)', '🔥 Şut');

    // En yakın takım arkadaşına pas yönü
    let nearest = null;
    let minDist = Infinity;
    for (const p of team) {
      if (p === player) continue;
      const dd = dist(player.x, player.y, p.x, p.y);
      if (dd < minDist) { minDist = dd; nearest = p; }
    }
    if (nearest) {
      drawAimArrow(ctx, ball.x, ball.y, nearest.x, nearest.y, 'rgba(46,204,113,0.4)', '➡️ Pas');
    }
  }
}

// FIFA tarzı radar mini-harita
export function drawRadar(ctx, state, x, y, radarW, radarH) {
  const { canvasW, canvasH, homeTeam, awayTeam, ball } = state;

  // Arka plan
  ctx.fillStyle = 'rgba(0,30,0,0.85)';
  ctx.strokeStyle = 'rgba(255,255,255,0.3)';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.roundRect(x, y, radarW, radarH, 4);
  ctx.fill();
  ctx.stroke();

  // Saha çizgileri
  ctx.strokeStyle = 'rgba(255,255,255,0.15)';
  ctx.lineWidth = 0.5;
  // Orta çizgi
  ctx.beginPath();
  ctx.moveTo(x + radarW / 2, y);
  ctx.lineTo(x + radarW / 2, y + radarH);
  ctx.stroke();
  // Orta daire
  ctx.beginPath();
  ctx.arc(x + radarW / 2, y + radarH / 2, radarH * 0.2, 0, Math.PI * 2);
  ctx.stroke();

  const scaleX = radarW / canvasW;
  const scaleY = radarH / canvasH;

  // Ev sahibi oyuncular
  for (const p of homeTeam) {
    ctx.fillStyle = p.isGoalkeeper ? '#f39c12' : state.homeTeamData.colors.primary;
    ctx.beginPath();
    ctx.arc(x + p.x * scaleX, y + p.y * scaleY, p.isGoalkeeper ? 2.5 : 2, 0, Math.PI * 2);
    ctx.fill();
  }

  // Deplasman oyuncular
  for (const p of awayTeam) {
    ctx.fillStyle = p.isGoalkeeper ? '#f39c12' : state.awayTeamData.colors.primary;
    ctx.beginPath();
    ctx.arc(x + p.x * scaleX, y + p.y * scaleY, p.isGoalkeeper ? 2.5 : 2, 0, Math.PI * 2);
    ctx.fill();
  }

  // Top
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(x + ball.x * scaleX, y + ball.y * scaleY, 2.5, 0, Math.PI * 2);
  ctx.fill();
}

// FIFA tarzı güç barı
export function drawPowerBar(ctx, x, y, w, h, power) {
  if (power <= 0) return;

  // Arka plan
  ctx.fillStyle = 'rgba(0,0,0,0.7)';
  ctx.beginPath();
  ctx.roundRect(x - 2, y - 2, w + 4, h + 4, 4);
  ctx.fill();

  // Güç barı dolumu
  const fillW = w * Math.min(power, 1);
  const grad = ctx.createLinearGradient(x, y, x + w, y);
  grad.addColorStop(0, '#2ecc71');
  grad.addColorStop(0.5, '#f1c40f');
  grad.addColorStop(0.8, '#e67e22');
  grad.addColorStop(1, '#e74c3c');
  ctx.fillStyle = grad;
  ctx.beginPath();
  ctx.roundRect(x, y, fillW, h, 3);
  ctx.fill();

  // Parlama efekti
  ctx.fillStyle = 'rgba(255,255,255,0.2)';
  ctx.beginPath();
  ctx.roundRect(x, y, fillW, h / 2, [3, 3, 0, 0]);
  ctx.fill();
}

// FIFA tarzı oyuncu stamina göstergesi
export function drawPlayerStamina(ctx, player, isControlled) {
  if (!isControlled) return;
  const barW = 30;
  const barH = 3;
  const x = player.x - barW / 2;
  const y = player.y + 25;

  ctx.fillStyle = 'rgba(0,0,0,0.5)';
  ctx.fillRect(x - 1, y - 1, barW + 2, barH + 2);

  const ratio = player.stamina / 100;
  const color = ratio > 0.5 ? '#2ecc71' : ratio > 0.25 ? '#f1c40f' : '#e74c3c';
  ctx.fillStyle = color;
  ctx.fillRect(x, y, barW * ratio, barH);
}

// FIFA tarzı kart göstergesi
export function drawCardIndicator(ctx, x, y, cardType) {
  const size = 8;
  ctx.fillStyle = cardType === 'red' ? '#e74c3c' : '#f1c40f';
  ctx.fillRect(x - size / 2, y - size, size, size * 1.4);
  ctx.strokeStyle = 'rgba(0,0,0,0.3)';
  ctx.lineWidth = 0.5;
  ctx.strokeRect(x - size / 2, y - size, size, size * 1.4);
}

// FIFA tarzı sprint izi efekti
export function drawSprintTrail(ctx, player, isSprinting) {
  if (!isSprinting) return;
  const speed = Math.sqrt((player.vx || 0) ** 2 + (player.vy || 0) ** 2);
  if (speed < 2) return;

  ctx.globalAlpha = 0.15;
  ctx.fillStyle = player.teamColor;
  for (let i = 1; i <= 3; i++) {
    const trailX = player.x - (player.vx || 0) * i * 2;
    const trailY = player.y - (player.vy || 0) * i * 2;
    ctx.beginPath();
    ctx.arc(trailX, trailY, PLAYER_RADIUS * (1 - i * 0.2), 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.globalAlpha = 1;
}
